module.exports = __webpack_public_path__ + "img/powered_suppy_black.2ab78600.png";